import React, { ReactNode } from 'react';

type Props = { children: ReactNode; title?: never } | { title: string; children?: never };
const MethodsSectionTitle = ({ children, title }: Props) => {
    return <p className="mb-1 font-semibold text-gray-900">{children ?? title}</p>;
};

export default MethodsSectionTitle;
